module.exports = __webpack_public_path__ + "img/baizhi-back-three.ee79cbb5.png";